import React from "react";
import Menu from "./Menu";

const OurMenu = () => {
  return (
    <div>
      <Menu />
    </div>
  );
};

export default OurMenu;
